export function debounceHelper(func, delay) {
  let timeoutId;
  return function (...args) {
    clearTimeout(timeoutId);
    timeoutId = setTimeout(() => {
      func.apply(this, args);
    }, delay);
  };
}

export const debounce = (func, timeout = 500) => {
  let timer;
  let resolveCallback;

  return (...args) => {
    return new Promise((resolve) => {
      clearTimeout(timer);

      resolveCallback = resolve;

      timer = setTimeout(() => {
        const result = func.apply(this, args);
        resolveCallback(result);
      }, timeout);
    });
  };
};
